<div class="country-currency">
  <img [src]="image" alt="country" />
  <label class="currency">{{ currency }}</label>
</div>
